import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { inject, observer } from 'mobx-react';
import { StringInput } from 'modules/core/components/forms';
import { FormModal } from 'modules/core/containers';
import { toJS } from 'mobx';

import { ComponentProps, useState } from 'react';
import type { FormikProps } from 'formik';
import { ProjectSelector } from 'modules/core/components/selectors/';
import {
  promoActions,
  PromoStore,
} from '../store/promoStore';
import { ClientPromoInterface } from '../api/promoApi';
import { PromoSelector } from '../../core/components/selectors';
import { ClientPromoEditValidationSchema } from './validation';

interface ClientPromoEditProps {
  clientId: string,
  onClose?: (...args: unknown[]) => unknown,
  onSubmit?: (...args: unknown[]) => unknown,
  promoStore?: PromoStore,
}

type TForm = ComponentProps<typeof FormModal> & Pick<FormikProps<any>, 'resetForm' | 'setSubmitting'>

const ClientPromoEdit = (props: ClientPromoEditProps) => {
  const {
    clientId,
    onClose,
    promoStore,
    onSubmit,
  } = props;

  const currentClientPromo = toJS(promoStore.currentClientPromo);

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: ClientPromoInterface, form: TForm) => {
    try {
      if (currentClientPromo) {
        await promoActions.updateClientPromo(values.id, {
          comment: values.comment,
          usedCount: values.usedCount ?? 0,
        });
      } else {
        await promoActions.createClientPromo({
          clientId,
          comment: values.comment,
          promoId: values.promoId,
          sourceProjectId: values.sourceProjectId,
        });
      }

      form.resetForm();
      if (typeof onSubmit === 'function') {
        onSubmit();
      }
    } finally {
      form.setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);

    try {
      if (currentClientPromo?.deletedDate) {
        await promoActions.restoreClientPromo(currentClientPromo.id);
      } else {
        await promoActions.deleteClientPromo(currentClientPromo.id);
      }

      if (onSubmit != null) {
        onSubmit();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    // @ts-ignore
    <FormModal
      show={ true }
      initialValues={ { ...currentClientPromo } }
      validationSchema={ ClientPromoEditValidationSchema }
      onClose={ onClose }
      onCancel={ onClose }
      onSubmit={ handleSubmit }
      header={ currentClientPromo?.id ? 'Редактирование промоакции' : 'Добавление промоакции клиенту' }
      submitButtonTitle={ currentClientPromo?.id ? 'Сохранить' : 'Добавить' }
      loading={ loading }
      showDeleteButton={ !!currentClientPromo }
      deleteButtonTitle={ currentClientPromo?.deletedDate ? 'Восстановить' : 'Сделать не активным' }
      onDelete={ handleDelete }
      // dialogClassName='tab-container-modal'
    >
      { ({ values, setFieldValue }) => (
        <Row>
          <Col md={ 6 }>
            <ProjectSelector
              name='sourceProjectId'
              placeholder='Проект'
              disabled={ Boolean(currentClientPromo) }
              label='Проект'
              onChange={ () => { setFieldValue('promoId', null); } }
            />
          </Col>
          <Col md={ 6 }>
            <PromoSelector
              name='promoId'
              placeholder='Акция'
              disabled={ Boolean(currentClientPromo) || !values.sourceProjectId }
              label='Акция'
              projectId={ values.sourceProjectId }
            />
          </Col>

          <Col md={ 12 }>
            <StringInput
              name='comment'
              as='textarea'
              placeholder='Комментарий'
              label='Комментарий'
            />
          </Col>
          <Col md={ 6 }>
            <StringInput
              name='usedCount'
              placeholder='Использований'
              label='Использований'
              disabled={ !currentClientPromo }
              type='number'
            />
          </Col>
        </Row>
      ) }
    </FormModal>
  );
};

export default inject('promoStore')(observer(ClientPromoEdit));
